<template>
  <div>
    <!--
    <div class="do-info-box" role="note" aria-label="Forklaring af puljer">
      <h3>Sådan virker differentierede puljer</h3>

      <h4>For klassen</h4>
      <p class="marg-1-bottom">Klassens klokketimer i skoleåret kan afvige fra brikkens standard fx ved
        fagreduktioner.</li>
      </p>
      <h4>For underviseren</h4>
      <p>Underviserens klokketimer i skoleåret kan afvige på to måder:</p>
      <ol>
        <li>Der er indtastet en specifik pulje for underviseren.</li>
        <li>En tilknyttet klasse har en pulje, der afviger fra brikken.</li>
      </ol>
      <p>Hvis hverken underviseren eller klassen har en pulje, anvendes brikkens standard.</p>
    </div>
  -->
    <table class="calendars-hours-table">
      <thead>
      <th></th>
      <th><label class="d-label">Klokketimer i skoleåret</label></th>
      <th></th>
      </thead>
      <tr class="calendar-item calendar-item--subject">
        <td><strong>Brikken</strong></td>
        <td>
          <input
            class="do-input"
            type="number"
            step="0.1"
            :value="subjectHoursInput"
            @focus="selectAll"
            @input="subjectHoursInput = $event.target.value"
          >
        </td>
        <td>
          <button
            class="do-bttn do-bttn--submit"
            :class="{
              'do-bttn--submit--loading': isSavingSubjectHours,
              'do-bttn--submit--disabled': !isSubjectHoursChanged }"
            :disabled="isSavingSubjectHours || !isSubjectHoursChanged"
            @click="submitSubjectHours"
          >
            Gem
          </button>
        </td>
      </tr>
      <tr
        v-for="row in sortedRows"
        :key="row.calendar_id"
        class="calendar-item"
      >
        <td>
          {{ calendarName(row.calendar_id) }}
          <div
            v-if="differsFromSubject(row)"
            class="do-pill do-pill--yellow calendars-hours-pill"
          >afviger fra brikken ({{ subjectDefaultHours() }})</div>
        </td>
        <td v-if="isEditable(row.calendar_id)">
          <input
            class="do-input"
            type="number"
            step="0.1"
            :value="row.hours"
            :placeholder="fallbackPlaceholder(row)"
            @focus="selectAll"
            @input="onInput(row.calendar_id, $event.target.value)"
          >
        </td>
        <td v-else>
          <span>
            {{ displayHours(row) }}
            <div class="do-pill do-pill--yellow calendars-hours-pill" >{{ displayHoursSource(row) }}</div>
          </span>
        </td>
        <td>
          <button
            v-if="isEditable(row.calendar_id)"
            class="do-bttn do-bttn--submit"
            :class="{ 
              'do-bttn--submit--loading': savingRows[row.calendar_id],
              'do-bttn--submit--disabled': !isChanged(row) }"
            :disabled="savingRows[row.calendar_id] || !isChanged(row)"
            @click="submitRow(row.calendar_id)"
          >
            Gem
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import docendo from '../../docendo'

export default {
  props: {
    subject: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      localRows: this.subject && this.subject.subject_calendars
        ? this.subject.subject_calendars.map(function (sc) {
          return {calendar_id: sc.calendar_id, hours: sc.hours}
        })
        : [],
      originalByCalId: this.subject && this.subject.subject_calendars
        ? this.subject.subject_calendars.reduce(function (acc, sc) {
          acc[sc.calendar_id] = sc.hours
          return acc
        }, {})
        : {},
      calsById: this.subject && this.subject.cals
        ? this.subject.cals.reduce(function (acc, c) {
          acc[c.id] = {name: c.name, calendar_type: c.calendar_type}
          return acc
        }, {})
        : {},
      savingRows: {},
      savedSubjectHours: this.subject ? this.subject.hours : null,
      subjectHoursInput: this.subject && this.subject.hours != null ? String(this.subject.hours) : '',
      isSavingSubjectHours: false
    }
  },
  computed: {
    isSubjectHoursChanged () {
      if (this.subjectHoursInput === '' || this.subjectHoursInput == null) return false
      return parseFloat(this.subjectHoursInput) !== parseFloat(this.savedSubjectHours)
    },
    sortedRows () {
      const self = this
      const rows = this.localRows.filter(function (r) {
        return !self.isRoomCalendar(r.calendar_id)
      })

      return rows.slice().sort(function (a, b) {
        const ma = self.calsById[a.calendar_id] || {}
        const mb = self.calsById[b.calendar_id] || {}

        const priA = ma.calendar_type === 'klass' ? 0 : 1
        const priB = mb.calendar_type === 'klass' ? 0 : 1
        if (priA !== priB) return priA - priB

        const na = ma.name ? ma.name.toLowerCase() : ''
        const nb = mb.name ? mb.name.toLowerCase() : ''
        if (na < nb) return -1
        if (na > nb) return 1

        return String(a.calendar_id).localeCompare(String(b.calendar_id))
      })
    }
  },
  methods: {
    isRoomCalendar (calendarId) {
      const meta = this.calsById[calendarId]
      if (!meta || !meta.calendar_type) return false
      const t = String(meta.calendar_type).toLowerCase()
      // Tilpas listen hvis I bruger andre typer for lokaler
      if (t === 'room') {
        return true
      }
      return false
    },
    displayHoursSource (row) {
      // Hvis rækken har en egen værdi, er kilden "sat på denne kalender"
      if (row.hours != null) return 'sat på denne kalender'

      const type = this.calendarType(row.calendar_id)

      // For bruger-kalendere: fald tilbage til klassens værdi hvis sat, ellers brikken
      if (type === 'user') {
        const ch = this.classSetHours()
        if (ch != null) return 'fra klassens pulje'
        return 'fra brikken'
      }

      // For klasse-kalendere (eller andre): vises brikkens standard hvis ikke sat
      if (type === 'klass') return 'fra brikken'

      return 'fra brikken'
    },
    selectAll (event) {
      setTimeout(function () {
        event.target.select()
      }, 0)
    },
    calendarMeta (calendarId) {
      return this.calsById[calendarId] || {}
    },
    calendarType (calendarId) {
      const meta = this.calendarMeta(calendarId)
      return meta.calendar_type || ''
    },
    isEditable (calendarId) {
      const type = this.calendarType(calendarId)
      return type === 'user' || type === 'klass'
    },
    differsFromSubject (row) {
      if (this.calendarType(row.calendar_id) !== 'klass') return false
      if (this.originalByCalId[row.calendar_id] == null) return false
      const saved = parseFloat(this.originalByCalId[row.calendar_id])
      const subjectHours = parseFloat(this.subjectDefaultHours())
      if (isNaN(saved) || isNaN(subjectHours)) return false
      return saved !== subjectHours
    },
    calendarName (calendarId) {
      const meta = this.calendarMeta(calendarId)
      if (meta && meta.name) return meta.name
      if (!this.subject || !this.subject.cals) return '' + calendarId
      for (let i = 0; i < this.subject.cals.length; i++) {
        const c = this.subject.cals[i]
        if (c && c.id === calendarId) return c.name
      }
      return '' + calendarId
    },
    firstClassCalendarId () {
      if (!this.subject || !Array.isArray(this.subject.cals)) return null
      for (let i = 0; i < this.subject.cals.length; i++) {
        const c = this.subject.cals[i]
        if (c && c.calendar_type === 'klass') return c.id
      }
      return null
    },
    classSetHours () {
      const classId = this.firstClassCalendarId()
      if (classId == null) return null
      for (let i = 0; i < this.localRows.length; i++) {
        const r = this.localRows[i]
        if (r && r.calendar_id === classId) {
          return r.hours != null ? r.hours : null
        }
      }
      return null
    },
    subjectDefaultHours () {
      if (this.savedSubjectHours == null) return ''
      return this.savedSubjectHours
    },
    submitSubjectHours () {
      if (!this.isSubjectHoursChanged) return
      const hours = parseFloat(this.subjectHoursInput)
      this.isSavingSubjectHours = true
      docendo.bulkUpdateSubjects(this.subject.school_id, [this.subject.id], {hours: hours}, data => {
        const subjects = typeof data === 'string' ? JSON.parse(data) : data
        if (Array.isArray(subjects)) {
          subjects.forEach(subj => {
            subj.calendar_ids = subj.cals ? subj.cals.map(c => c.id) : (subj.calendar_ids || [])
            this.$store.commit('updateSubject', subj)
          })
        }
        this.savedSubjectHours = hours
        this.subjectHoursInput = String(hours)
        this.isSavingSubjectHours = false
        this.$emit('subjectHoursSaved', hours)
      }, () => {
        this.isSavingSubjectHours = false
      })
    },
    displayHours (row) {
      if (row.hours != null) return row.hours
      const type = this.calendarType(row.calendar_id)
      if (type === 'user') {
        const ch = this.classSetHours()
        if (ch != null) return ch
        return this.subjectDefaultHours()
      }
      if (type === 'klass') return this.subjectDefaultHours()
      return this.subjectDefaultHours()
    },
    fallbackPlaceholder (row) {
      const val = this.displayHours(row)
      const source = this.displayHoursSource(row)
      if (val === '' || val == null) return ''
      return val + ' (' + source + ')'
    },
    onInput (calendarId, value) {
      const idx = this.localRows.findIndex(function (r) {
        return r && r.calendar_id === calendarId
      })
      if (idx < 0) return
      // Tøm input => sæt til null så vi igen viser fallback
      const val = value === '' ? null : String(value)
      this.$set(this.localRows, idx, {
        calendar_id: this.localRows[idx].calendar_id,
        hours: val
      })
    },
    desiredHoursToSave (row) {
      if (row.hours != null) return String(row.hours)
      return null
    },
    isChanged (row) {
      const prev = this.originalByCalId[row.calendar_id] == null
        ? null
        : String(this.originalByCalId[row.calendar_id])
      const desired = this.desiredHoursToSave(row)
      return desired !== prev
    },
    submitRow (calendarId) {
      const idx = this.localRows.findIndex(function (r) {
        return r && r.calendar_id === calendarId
      })
      if (idx < 0) return

      const row = this.localRows[idx]
      const desired = this.desiredHoursToSave(row)

      // Hvis intet at gemme, så gør ingenting
      if (desired == null && this.originalByCalId[calendarId] == null) return

      const id = this.subject.id
      const schoolId = this.subject.school_id
      const schoolYearId = this.subject.school_year_id
      const hours = desired

      this.$set(this.savingRows, calendarId, true)

      docendo.setHoursForTeacherOnSubject(
        id,
        schoolId,
        schoolYearId,
        calendarId,
        hours,
        success => {
          this.originalByCalId[calendarId] = hours
          // Synkronisér localRows så input viser “sat” værdi fremadrettet
          const newVal = hours
          this.$set(this.localRows, idx, {
            calendar_id: calendarId,
            hours: newVal
          })
          this.$store.commit('updateTeacherHoursOnSubject', success)
          this.$set(this.savingRows, calendarId, false)
          // this.$emit('saved-row', {calendar_id: calendarId, hours: hours})
        },
        failure => {
          this.$set(this.savingRows, calendarId, false)
          // this.$emit('error', {calendar_id: calendarId, error: failure})
        }
      )
    }
  },
  watch: {
    subject: {
      handler (val, oldVal) {
        if (val && (!oldVal || val.id !== oldVal.id)) {
          this.savedSubjectHours = val.hours
          this.subjectHoursInput = val.hours != null ? String(val.hours) : ''
        }
        const rows = val && val.subject_calendars ? val.subject_calendars : []
        this.localRows = rows.map(function (sc) {
          return {calendar_id: sc.calendar_id, hours: sc.hours}
        })
        this.originalByCalId = rows.reduce(function (acc, sc) {
          acc[sc.calendar_id] = sc.hours
          return acc
        }, {})
        this.calsById = val && val.cals
          ? val.cals.reduce(function (acc, c) {
            acc[c.id] = {name: c.name, calendar_type: c.calendar_type}
            return acc
          }, {})
          : {}
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.calendars-hours-table {
  width: 100%;
  border-collapse: collapse;
}

.calendars-hours-table tr td:first-child {
  border-radius: 4px 0 0 4px;
}

.calendars-hours-table tr td:last-child {
  width: 50px;
  border-radius: 0 4px 4px 0;
}

.calendars-hours-table tr {
  padding: 0.25rem;
  border-radius: 4px;
  margin-bottom: 0.5rem;
  border: 1px solid #eee;
}

.calendars-hours-table tr:hover {
  background: #eee;
}

.calendars-hours-table tr.calendar-item--subject td {
  border-bottom: 1px solid #e2e8f0;
}

.calendars-hours-table tr td {
  padding: 0.25rem;
}

.calendars-hours-table tr td span {
  padding: 0 0.75rem;
}

.calendars-hours-table tr td:nth-child(2) {
  width: 200px;
}

.do-info-box {
  font-weight: 400;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: .5rem;
  margin-bottom: 1rem;
  font-size: 11px;
  line-height: 1.5;
  color: #a26206;
}

.calendars-hours-table tr td:first-child .calendars-hours-pill {
  margin-left: 0.5rem;
}

.calendars-hours-pill {
  text-transform: initial;
  padding: 0.25rem 0.5rem;
  display: inline-block;
  font-size: 11px;
  line-height: 11px;
}
</style>



// WEBPACK FOOTER //
// SubjectFormCalendarHours.vue?5fc10006